import { createTransform } from "redux-persist";

const EXPIRE_TIME = 60 * 60 * 24 * 1000; // Expires after 1 day

export const upSellingExpireTransform = createTransform(
  (inboundState: { _persistedAt: number } | undefined) => {
    return {
      ...(typeof inboundState === "object" ? inboundState : {}),
      _persistedAt: inboundState?._persistedAt || Date.now(),
    };
  },
  (outboundState) => {
    if (!outboundState || !outboundState._persistedAt) {
      return outboundState;
    }

    const currentTime = Date.now();
    if (currentTime - outboundState._persistedAt > EXPIRE_TIME) {
      console.log("UpsellingApiSlice expired, clearing data...");

      return undefined;
    }

    return outboundState;
  },
  { whitelist: ["queries", "mutations"] }
);
